<template lang="pug">
  .user-settings
    .user-settings__title
      h1.title Настройки аккаунта
    .user-settings__main
      .profile-page-form
        .profile-page-form__section-container
          section.profile-page-form__section.profile-section
            .profile-section__title
              h2.profile-section-title Пароль
            .profile-section__body
              form-password
          section.profile-page-form__section.profile-section
            .profile-section__title
              h2.profile-section-title Логин
            .profile-section__body
              form-login

</template>

<script>
import FormLogin from "./components/form-login";
import FormPassword from "../../../../components/form-password/form-password";
export default {
  name: "user-settings",
  components: { FormPassword, FormLogin },
};
</script>
